import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ChangePasswordRequest } from '@models/usuario/changePasswordRequest.model';
import { CreateUserResponse } from '@models/usuario/createUserResponse.model';
import { DeleteUserRequest } from '@models/usuario/deleteUserRequest.model';
import { ForgotPasswordRequest } from '@models/usuario/forgotPasswordRequest.model';
import { UpdateRolInUserRequest } from '@models/usuario/updateRolInUserRequest.model';
import { UpdateUsuarioRequest } from '@models/usuario/updateUsuarioRequest.model';
import { UpdateUserResponse } from '@models/usuario/updateUserResponse.model';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { isFalsy } from 'utility-types';
import { MessageSuccessfullDto } from '@models/base/MessageSuccessfullDto.model';
import { CreateUsuarioRequest } from '@models/usuario/createUsuarioRequest.model';
import { UsuarioFilter } from '@models/usuario/usuarioFilter.model';


@Injectable({
  providedIn: 'root'
})
export class UsuarioService {


  lstUsuarioDto: UsuarioDto[] = [];

  // private readonly urlBase = `${environment.apiUrl}`;
  userString: any;

  private id!: number;

  set setId(id: number) {
    this.id = id;
  }

  get getId() {
    return this.id;
  }

  constructor(
    private http: HttpClient,
  ) {
  }

  getUserByName(userName: string): Observable<UsuarioDto> {
    return this.http.get<UsuarioDto>("/api/Usuario/GetUserByUserName?userName=" + userName);
  }


  getAllDataOfUserByUserName(userName: string): Observable<UsuarioDto> {
    return this.http.get<UsuarioDto>("/api/Usuario/GetAllDataOfUserByUserName?userName=" + userName);
  }

  getUserById(id: number): Observable<UsuarioDto> {
    return this.http.get<UsuarioDto>("/api/Usuario/GetUserById?IdUser=" + id);
  }

  getAll(): Observable<UsuarioDto[]> {
    return this.http.get<UsuarioDto[]>("/api/Usuario/GetAll");
  }

  getAllByFilter(usuarioFilter: UsuarioFilter): Observable<UsuarioDto[]> {
    return this.http.post<UsuarioDto[]>("/api/Usuario/GetAllByFilter", usuarioFilter);
  }


  create(createUsuarioRequest: CreateUsuarioRequest): Observable<CreateUserResponse> {
    return this.http.post<CreateUserResponse>("/api/Usuario/Create", createUsuarioRequest);
  }

  register(createUsuarioRequest: CreateUsuarioRequest): Observable<CreateUserResponse> {
    return this.http.post<CreateUserResponse>("/api/Usuario/Register", createUsuarioRequest);
  }

  update(updateUserRequest: UpdateUsuarioRequest): Observable<UpdateUserResponse> {
    return this.http.post<UpdateUserResponse>("/api/Usuario/Update", updateUserRequest);
  }

  deleteLogic(deleteUserRequest: DeleteUserRequest): Observable<boolean> {
    return this.http.post<boolean>("/api/Usuario/Delete", deleteUserRequest);
  }


  recoverPassword(forgotPasswordRequest: ForgotPasswordRequest): Observable<MessageSuccessfullDto> {
    return this.http.post<MessageSuccessfullDto>("/api/Usuario/ForgotPassword", forgotPasswordRequest)
  }

  changePassword(changePasswordRequest: ChangePasswordRequest): Observable<MessageSuccessfullDto> {
    return this.http.post<MessageSuccessfullDto>("/api/Usuario/ChangePassword", changePasswordRequest)
  }

  updateRolInUser(updateRolInUserRequest: UpdateRolInUserRequest): Observable<MessageSuccessfullDto> {
    return this.http.post<MessageSuccessfullDto>("/api/Usuario/UpdateRolInUser", updateRolInUserRequest)
  }

  verifyCodeCorreo(idUsuario: number, code: string): Observable<any> {
    return this.http.post<any>("/api/Usuario/VerifyCodeCorreo?idUsuario=" + idUsuario + "&code=" + encodeURIComponent(code), null);
  }

  resendVerificationCodeCorreo(idUsuario: number): Observable<any> {
    return this.http.post<any>("/api/Usuario/ResendVerificationCodeCorreo?idUsuario=" + idUsuario, null);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/Usuario/Delete?id=" + id);
    else
      return of(null)
  }

}
